

module.exports = __webpack_require__.stylable.create(
    "Loader3601040114",
    {"classes":{"root":"Loader3601040114__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Loader3601040114",
    null
);
